module.exports = __webpack_public_path__ + "img/Locked.e62ae735.svg";